import { Flex, Text, Button } from "@gravity-ui/uikit";
import { Link } from "react-router-dom";
import { T } from "src/i18n";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { Footer } from "src/widgets/Footer/Footer";
import { Header } from "src/widgets/Header/Header";

import css from "./DocumentViewer.module.scss";

interface DocumentViewerProps {
  title: string;
  pdfUrl: string;
  documentTitle: string;
}

export const DocumentViewer = ({
  title,
  pdfUrl,
  documentTitle,
}: DocumentViewerProps) => {
  return (
    <Flex direction={"column"} alignItems={"center"} className={css.page}>
      <Header
        actions={
          <>
            <Link to={RoutesPaths.LK.BASE_PATH}>
              <Button size="l" view="action" className={css.button}>
                <Text variant="subheader-1">
                  <T
                    keyName="header.login_button"
                    defaultValue="Начать пользоваться"
                  />
                </Text>
              </Button>
            </Link>
          </>
        }
      />

      <div className={css.content}>
        <Text variant="header-1" className={css.title}>
          {title}
        </Text>
        <div className={css.documentContainer}>
          <iframe src={pdfUrl} className={css.pdfFrame} title={documentTitle} />
        </div>
      </div>
      <Footer />
    </Flex>
  );
};
